<template>
  <div id="app">
    <b-container>
      <b-img fluid center alt="South Dakota Mines logo" :src="require('./assets/sig-logo.png')" id="logo"/>
      <Intro />
      <SignatureForm />
      <hr />
      <Instructions />
    </b-container>
  </div>
</template>

<script>
import Intro from './components/Intro.vue';
import SignatureForm from './components/SignatureForm.vue';
import Instructions from './components/Instructions.vue';
// import VueForm from './components/VueForm.vue';
// import SigTemplate from './components/SigTemplate.vue';

export default {
  name: "App",
  components: {
    Intro,
    SignatureForm,
    Instructions,
  }
}
</script>

<style scoped>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

#logo {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue